import { Injectable, inject } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';
import { Nexus } from '@tomandco/nexus-api-types';
import { ProductConfigurationBundle } from '../product-configuration-bundle';
import { BundleOption } from './option/bundle-option';

@Injectable()
export class ProductConfigurationBundleOptionService {
    /**
     * Cache for bundle options
     */
    private optionsCache = new Map<Product, BundleOption[]>();

    /**
     * Product resource
     */
    private productResource = inject(ProductResource);

    /**
     * Prepeares custom options models set
     */
    getOptions(product: Product<IProductDataV3>, configuration: ProductConfigurationBundle): BundleOption[] {
        if (!this.optionsCache.has(product)) {
            this.optionsCache.set(
                product,
                product.data!.options!.bundle!.map(data => {
                    return new BundleOption(data, this.productResource, configuration);
                })
            );
        }
        return this.optionsCache.get(product)!;
    }

    /**
     * Converts options selection to buy request
     */
    getRequestOptions(options: BundleOption[] | undefined): Nexus.Lib.Basket.BundleSelectionData | undefined {
        if (options) {
            const request: Nexus.Lib.Basket.BundleSelectionData = {};
            options
                .map(option => option.toRequest())
                .forEach(i => {
                    if (i) {
                        request[i.key] = i.value;
                    }
                });
            return request;
        }
        return undefined;
    }

    setSelection(options: BundleOption[] | undefined, selection: Nexus.Lib.Basket.BundleSelectionData): void {
        options?.forEach(option => {
            option.values.forEach(optionValue => {
                optionValue.qty = selection[option.data.id]?.[optionValue.id] || 0;
            });
        });
    }

    validate(options: BundleOption[] | undefined): NProductConfiguration.Error.Entry[] | undefined {
        return options?.map(option => option.validate()).filter(i => !!i) as NProductConfiguration.Error.Entry[];
    }
}
